// extracted by mini-css-extract-plugin
export default {"list":"CardRows-module--list--7cd8f"};